const hostMedia = 'eventsgo/media/'
// env
export const GET_ENV = 'eventsgo/media/services/jalor/web/support/workspace/current'
// lang
export const GET_LANG = 'eventsgo/common/services/jalor/resource/i18nQuery/findI18nMap'
// 国家列表
export const GET_COUNTRY_LIST = hostMedia + 'services/eventsgo/public/geography/findGeographyInfoPagedList'
// 展会默认币种名称
export const GET_DEFAULT_CURRENCY = hostMedia + 'services/eventsgo/public/lookupService/list?classifyCode=CURRENCY_TYPE'
// 时区
export const GET_TIME_ZONE = hostMedia + 'services/eventsgo/public/lookupService/list?classifyCode=LOOKUP_TIMEZONE'
// 查询角色权限
export const GET_USER_PERM = 'eventsgo/common/services/eventsgo/common/permissions/single/page'
// 删除角色
export const GET_DEL_PERM = 'eventsgo/common/services/eventsgo/common/permissions/delete/bacth'
// 延期角色
export const GET_POSTPONE_PERM = 'eventsgo/common/services/eventsgo/common/permissions/postpone/bacth'
// 添加角色
export const GET_ADD_PERM = 'eventsgo/common/services/eventsgo/common/permissions/add'
// 用户权限获得延期最大时间
export const GET_SINGLE_PERM = 'eventsgo/common/services/jalor/security/userPermission/single/postponement'
// 获取是否关联ICIMS展会
export const GET_IS_ICIMS_EXHI = hostMedia + 'services/eventsgo/public/exhibitions/isIcimsLiaise'

/** 第三方登录获取跳转机票火车票的地址 */
export const GET_TRAVEL_LOGIN_URL = 'eventsgo/media/services/eventsgo/personcenter/personalInfo/getTravelLoginurl'

/** 上传附件 */
export const UPLOAD_ATTACHMENT = 'eventsgo/attachment/servlet/upload'
// 切换语言
export const SWITCH_LANGUAGE = hostMedia + 'services/eventsgo/public/home/language/switch'
// 数据字典配置爱上会
export const COMMON_LOOKUP_DATA = hostMedia + 'services/eventsgo/public/lookupService/list'
// 上传图片
export const UPLOAD_IMAGE = hostMedia + 'services/eventsgo/attachment/file/upload?ulType=eventsgoAttachment'
